"use client";

import { FC } from "react";
import {
  BarLoader,
  BeatLoader,
  BounceLoader,
  CircleLoader,
  ClimbingBoxLoader,
  ClipLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  MoonLoader,
  PacmanLoader,
  PropagateLoader,
  PuffLoader,
  PulseLoader,
  RingLoader,
  RiseLoader,
  RotateLoader,
  ScaleLoader,
  SkewLoader,
  SquareLoader,
  SyncLoader,
} from "react-spinners";

interface TLoaderProps {
  type:
    | "BarLoader"
    | "BeatLoader"
    | "BounceLoader"
    | "CircleLoader"
    | "ClimbingBoxLoader"
    | "ClipLoader"
    | "ClockLoader"
    | "DotLoader"
    | "FadeLoader"
    | "GridLoader"
    | "HashLoader"
    | "MoonLoader"
    | "PacmanLoader"
    | "PropagateLoader"
    | "PuffLoader"
    | "PulseLoader"
    | "RingLoader"
    | "RiseLoader"
    | "RotateLoader"
    | "ScaleLoader"
    | "SkewLoader"
    | "SquareLoader"
    | "SyncLoader";
  size?: number;
  color?: string;
}

const Loader: FC<TLoaderProps> = ({
  size = 15,
  type = "BarLoader",
  color = "#5595C3FF",
}: TLoaderProps) => {
  // Définition des propriétés communes globalement
  const commonProps = { color };

  // Sélection et rendu du loader basé sur le type
  const renderLoader = () => {
    const LoaderComponent = (() => {
      switch (type) {
        case "BarLoader":
          return BarLoader;
        case "BeatLoader":
          return BeatLoader;
        case "BounceLoader":
          return BounceLoader;
        case "CircleLoader":
          return CircleLoader;
        case "ClimbingBoxLoader":
          return ClimbingBoxLoader;
        case "ClipLoader":
          return ClipLoader;
        case "ClockLoader":
          return ClockLoader;
        case "DotLoader":
          return DotLoader;
        case "FadeLoader":
          return FadeLoader;
        case "GridLoader":
          return GridLoader;
        case "HashLoader":
          return HashLoader;
        case "MoonLoader":
          return MoonLoader;
        case "PacmanLoader":
          return PacmanLoader;
        case "PropagateLoader":
          return PropagateLoader;
        case "PuffLoader":
          return PuffLoader;
        case "PulseLoader":
          return PulseLoader;
        case "RingLoader":
          return RingLoader;
        case "RiseLoader":
          return RiseLoader;
        case "RotateLoader":
          return RotateLoader;
        case "ScaleLoader":
          return ScaleLoader;
        case "SkewLoader":
          return SkewLoader;
        case "SquareLoader":
          return SquareLoader;
        case "SyncLoader":
          return SyncLoader;
        default:
          return BarLoader;
      }
    })();

    // Certains loaders n'acceptent pas la prop `size`, mais `BarLoader` utilise `width`
    const additionalProps = type === "BarLoader" ? { width: size } : { size };

    return <LoaderComponent {...commonProps} {...additionalProps} />;
  };

  return <div className='flex justify-center'>{renderLoader()}</div>;
};

export default Loader;
